<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">Guardian Guerrillas</h1>
<ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li>
<li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-4"><a href="#/text/ch004#acknowledgment">Acknowledgment</a></li>
<li id="toc-li-5"><a href="#/text/ch005#preface">Preface</a></li>
<li id="toc-li-6"><a href="#/text/ch006#prologue">Prologue</a></li>
<li id="toc-li-7"><a href="#/text/ch007#reunion">Reunion</a></li>
<li id="toc-li-8"><a href="#/text/ch008#recruitment">Recruitment</a></li>
<li id="toc-li-9"><a href="#/text/ch009#the-sni-a-bar">The Sni-A-Bar</a></li>
<li id="toc-li-10"><a href="#/text/ch010#delivering-the-mail">‘Delivering the Mail’</a></li>
<li id="toc-li-11"><a href="#/text/ch011#pirates-of-the-missouri">‘Pirates of the Missouri’</a></li>
<li id="toc-li-12"><a href="#/text/ch012#the-battle-of-the-ravines">The Battle of the Ravines</a></li>
<li id="toc-li-13"><a href="#/text/ch013#beating-buel">Beating Buel</a></li>
<li id="toc-li-14"><a href="#/text/ch014#the-swearing-in">The Swearing in</a></li>
<li id="toc-li-15"><a href="#/text/ch015#bloody-bill-and-brother-jim-join-our-band">‘Bloody Bill’ and Brother Jim Join Our Band</a></li>
<li id="toc-li-16"><a href="#/text/ch016#the-tale-of-the-private-and-two-lieutenants">The Tale of the Private and Two Lieutenants</a></li>
<li id="toc-li-17"><span href="#/text/ch017#remember-osceola" title="Link target outside of Sample">Remember Osceola</span></li>
<li id="toc-li-18"><span href="#/text/ch018#battle-of-the-big-hill" title="Link target outside of Sample">Battle of the ‘Big Hill’</span></li>
<li id="toc-li-19"><span href="#/text/ch019#for-want-of-uniforms" title="Link target outside of Sample">For Want of Uniforms</span></li>
<li id="toc-li-20"><span href="#/text/ch020#do-not-attack-a-brick-building-with-pistols" title="Link target outside of Sample">Do Not Attack a Brick Building with Pistols</span></li>
<li id="toc-li-21"><span href="#/text/ch021#saving-shelby" title="Link target outside of Sample">Saving Shelby</span></li>
<li id="toc-li-22"><span href="#/text/ch022#return-to-springfield" title="Link target outside of Sample">Return to Springfield</span></li>
<li id="toc-li-23"><span href="#/text/ch023#the-colonel-returns" title="Link target outside of Sample">The ‘Colonel’ Returns</span></li>
<li id="toc-li-24"><span href="#/text/ch024#for-mrs.-mccoy" title="Link target outside of Sample">For Mrs. McCoy</span></li>
<li id="toc-li-25"><span href="#/text/ch025#ripe-for-the-pickin" title="Link target outside of Sample">“Ripe for the Pickin”</span></li>
<li id="toc-li-26"><span href="#/text/ch026#homecoming" title="Link target outside of Sample">Homecoming</span></li>
<li id="toc-li-27"><span href="#/text/ch027#the-tale-of-riley-crawford" title="Link target outside of Sample">The Tale of Riley Crawford</span></li>
<li id="toc-li-28"><span href="#/text/ch028#revenge-by-ambush" title="Link target outside of Sample">Revenge by Ambush</span></li>
<li id="toc-li-29"><span href="#/text/ch029#malfeasance-or-murder" title="Link target outside of Sample">Malfeasance or Murder?</span></li>
<li id="toc-li-30"><span href="#/text/ch030#remember-the-murdered-women-of-kansas-city" title="Link target outside of Sample">Remember the Murdered Women of Kansas City!</span></li>
<li id="toc-li-31"><span href="#/text/ch031#the-burnt-district" title="Link target outside of Sample">The ‘Burnt’ District</span></li>
<li id="toc-li-32"><span href="#/text/ch032#beating-blunt" title="Link target outside of Sample">Beating Blunt</span></li>
<li id="toc-li-33"><span href="#/text/ch033#now-is-the-winter-of-our-discontent" title="Link target outside of Sample">‘Now Is the Winter of Our Discontent’</span></li>
<li id="toc-li-34"><span href="#/text/ch034#return-to-missouri" title="Link target outside of Sample">Return to Missouri</span></li>
<li id="toc-li-35"><span href="#/text/ch035#dingus-the-bushwhacker" title="Link target outside of Sample">‘Dingus’ the Bushwhacker</span></li>
<li id="toc-li-36"><span href="#/text/ch036#the-most-scared-fight" title="Link target outside of Sample">The Most Scared Fight</span></li>
<li id="toc-li-37"><span href="#/text/ch037#we-mustered-them-out" title="Link target outside of Sample">We ‘Mustered’ Them Out</span></li>
<li id="toc-li-38"><span href="#/text/ch038#deaths-of-two-titans" title="Link target outside of Sample">Deaths of Two Titans</span></li>
<li id="toc-li-39"><span href="#/text/ch039#the-last-ride-with-captain-clarke" title="Link target outside of Sample">The Last Ride with ‘Captain Clarke’</span></li>
<li id="toc-li-40"><span href="#/text/ch040#epilogue" title="Link target outside of Sample">Epilogue</span></li>
<li id="toc-li-41"><span href="#/text/ch041#bibliography" title="Link target outside of Sample">Bibliography</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?1287b563